import { onMounted, ref } from "vue";

export function onReceiveTaskNotification(
  callback: (notification: any) => void
) {
  // Replace this with your actual WebSocket setup and event handling logic
  // Example: Connect to WebSocket and call the callback when a notification is received
  const socket = new WebSocket("ws://https://localhost:7297/notifications");
  socket.addEventListener("message", (event) => {
    const notification = JSON.parse(event.data);
    callback(notification);
  });

  // Add other socket lifecycle logic as needed
}
